import { LocalizedText, LocalizedElement, sourceAttribute, useSourceLanguage } from "../i18n/LocalizedCopy";
import React, { useEffect, useState } from "react";

/** Lightweight brand visual while the route chunk is downloading. */
export default function PageLoading() {
  useSourceLanguage();
  const [slow, setSlow] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => setSlow(true), 10000);
    return () => clearTimeout(timer);
  }, []);
  return (
    <LocalizedElement elementType={"main"} copyAttributes={["aria-label"]} className="page-loading" aria-busy="true" aria-label={sourceAttribute("Chargement de votre espace")}>
      <div className="page-loading__visual" aria-hidden="true">
        <svg className="page-loading__art" viewBox="0 0 320 240" fill="none" focusable="false">
          <circle className="page-loading__halo" cx="160" cy="120" r="76" />
          <g className="page-loading__orbit">
            <ellipse cx="160" cy="120" rx="136" ry="70" transform="rotate(-25 160 120)" />
            <circle className="page-loading__star" cx="283" cy="63" r="4" />
            <circle className="page-loading__star page-loading__star--blue" cx="37" cy="177" r="3" />
          </g>
          <circle className="page-loading__ring" cx="160" cy="120" r="96" strokeDasharray="2 12" />
          <path className="page-loading__infinity" d="M160 120C142 96 132 88 115 88C73 88 73 152 115 152C132 152 142 144 160 120C178 96 188 88 205 88C247 88 247 152 205 152C188 152 178 144 160 120Z" />
          <path className="page-loading__glint" d="M67 52v12m-6-6h12M250 182v10m-5-5h10" />
        </svg>
      </div>
      <p role="status">{slow ? <LocalizedText source={"La connexion prend un peu plus de temps. Votre page est en cours de chargement."} /> : <LocalizedText source={"Préparation de votre espace…"} />}</p>
      <div className="page-loading__dots" aria-hidden="true"><span /><span /><span /></div>
      {slow && <button type="button" onClick={() => window.location.reload()}><LocalizedText source={"Réessayer le chargement"} /></button>}
    </LocalizedElement>
  );
}
